// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: false,
        requestInstantly: true /* boost-39900 */,
      activeLoadPreviousPage: true,
      paginationTypeAdvanced: true,
      paginationType: 'load_more',
    },
};

var bcSfFilterTemplate = {
    'gridBorderClass': 'grid-item-border',
    'onSaleClass': 'on-sale',
    'soldOutClass': 'sold-out',

    'quickViewHtml': '<div class="quickview-button"><a data-metafield="" data-pricedrop="{{dataPriceDropFlag}}" href="javascript:void(0)" id="{{itemHandle}}" title="' + bcSfFilterConfig.label.quick_view + '">' + bcSfFilterConfig.label.quick_view + '</a></div>',
    'reviewHtml': '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>',

    // Grid Template //' + bcSfFilterConfig.custom.grid_item_width + '
  'productGridItemHtml': '<div data-id="{{cstProductID}}" data-soldout="{{itemSoldOutClass}}" data-label="{{cst_custom_lab}}" data-tag="{{tagProductContactUs}}" data-ship="{{nofastshiplabel}}" class="grid-item reach_filte_code col-xs-6 col {{itemGridBorderClass}} {{itemCropImageClass}}">' +
                                '<div class="inner product-item {{itemSoldOutClass}} {{itemSaleClass}} wow fadeIn" data-wow-delay="{{delayTime}}ms" id="product-{{itemId}}">' +
                                    '<div class="inner-top">' +
                                        '<div class="product-top">' +
                                            '<div class="product-image">' +
                                                '<a href="{{itemUrl}}" class="product-grid-image">' +
                                                    '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                                    '<div class="hover"><img src="{{itemFlipImageUrl}}" alt="{{itemTitle}}" /></div>' +
                                                '</a>' +
                                            '</div>' +
                                            '{{itemLabels}}' +
                                            '<div class="product-des">' +
                                                '{{itemWishlist}}' +
                                                '<div class="action">{{itemAddToCart}}</div>' +
                                                '{{itemQuickView}}' +
  												'<div class="sold_out"> Out of stock </div>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="product-bottom v">' +
                                            '<a class="product-title test01" href="{{itemUrl}}" > {{itemVendor}} {{itemTitle}}</a>' +
  											'<span class="ogtitle hide">{{itemOgTitle}}</span><span class="spmtitle hide">{{itemSpmTitle}}</span>' + 
                                            '{{itemReview}}' +
                                            '<div class="price-box rc_js_file_2">{{itemPrice}}</div>' +
                                            '<a href="{{itemUrl}}" style="text-decoration: none;"></a>' +
                                            '{{itemColorSwatches}}' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>',

    // List Template
    'productListItemHtml':  '<div class="grid-item product-item {{itemSoldOutClass}} {{itemSaleClass}} wow fadeIn" data-wow-delay="{{delayTime}}ms" id="product-{{itemId}}">' +
                                '<div class="product-image">' +
                                    '<a href="{{itemUrl}}" class="product-list-thumb product-grid-image">' +
                                        '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                    '</a>' +
                                    '{{itemLabels}}' +
                                '</div>' +

                                '<div class="product-details">' +
                                    '<a class="product-title test02" href="{{itemUrl}}">{{itemTitle}}</a>' +
  									'<span class="ogtitle hide">{{itemOgTitle}}</span><span class="spmtitle hide">{{itemSpmTitle}}</span>' + 
                                    '{{itemVendor}}' +
                                    '{{itemReview}}' +
                                    '<div class="short-description">{{itemDescription}}</div>' +
                                    '{{itemColorSwatches}}' +
                                    '<div class="price-box rc_js_file_1">{{itemPrice}}</div>' +
                                    '<div class="action">{{itemAddToCart}}</div>' +
                                    '{{itemWishlist}}' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li class="text"><a href="{{itemUrl}}">Previous</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>Previous</span></li>',
    'nextActiveHtml': '<li class="text"><a href="{{itemUrl}}">Next</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>Next</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span>{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
};

BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
 
// console.log('data coming loop',data);
// console.log('index coming loop',index);
//   console.log('totalProduct coming loop',totalProduct);


    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/
	//console.dir( data ); //maddy...
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add class
    itemHtml = bcSfFilterConfig.custom.product_image_border ? itemHtml.replace(/{{itemGridBorderClass}}/g, bcSfFilterTemplate.gridBorderClass) : itemHtml.replace(/{{itemGridBorderClass}}/g, '');
    itemHtml = bcSfFilterConfig.custom.product_image_crop ? itemHtml.replace(/{{itemCropImageClass}}/g, 'crop_image') : itemHtml.replace(/{{itemCropImageClass}}/g, 'no_crop_image');
    itemHtml = soldOut ? itemHtml.replace(/{{itemSoldOutClass}}/g, bcSfFilterTemplate.soldOutClass) : itemHtml.replace(/{{itemSoldOutClass}}/g, '');
    itemHtml = onSale ? itemHtml.replace(/{{itemSaleClass}}/g, bcSfFilterTemplate.onSaleClass) : itemHtml.replace(/{{itemSaleClass}}/g, '');
    itemHtml = itemHtml.replace(/{{delayTime}}/g, bcSfFilterConfig.custom.time_lazy_load * index);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '1024x1024') : bcSfFilterConfig.general.no_image_url;
    var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]['src'], '1024x1024') : itemThumbUrl;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    itemHtml = itemHtml.replace(/{{itemFlipImageUrl}}/g, itemFlipImageUrl);

    // Add Label
    var itemLabelsHtml = '';
    if (onSale || soldOut) {
        itemLabelsHtml += '<div class="product-label">';
        if (onSale) {
            itemLabelsHtml += '<strong class="label">' + bcSfFilterConfig.label.sale + '</strong>';
        }
        if (soldOut) {
            itemLabelsHtml += '<strong class="sold-out-label">' + bcSfFilterConfig.label.sold_out + '</strong>';
        }
        itemLabelsHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);


    // Add Price
    var itemPriceHtml = '';
  var tags = data.tags;

if(tags.indexOf('pre-owned') >= 0 ){
    itemHtml = itemHtml.replace(/{{cst_custom_lab}}/g, 'pre-owned');

}

 if (tags.indexOf('store-display') >= 0 ){
    itemHtml = itemHtml.replace(/{{cst_custom_lab}}/g, 'store display');

}

//     if (onSale && !soldOut) {
       if (onSale && !soldOut && data.price_min !== 0 && tags.indexOf('product_ContactUs') < 1 ) {
        itemPriceHtml += '<p class="sale">';
        itemPriceHtml += '<span class="special-price">';
        if (priceVaries) {
            itemPriceHtml += '<em>' + bcSfFilterConfig.label.from_price + ' </em>';
        }      
        itemPriceHtml += this.formatMoney(data.price_min);
        itemPriceHtml += '</span>';
        itemPriceHtml += '<p class="old-price"> Retail ' + this.formatMoney(data.compare_at_price_min) +' </span></p>';      
        //itemPriceHtml += '';
      	
      	var cmpPrice = parseFloat( data.compare_at_price_min );
      	var salePrice = parseFloat( data.price_min );
      	var savePrice = cmpPrice - salePrice;
      	var savePercent = Math.round(((cmpPrice - salePrice) / cmpPrice) * 100);
      	itemPriceHtml += '<p class="you_save_loop">';
      	itemPriceHtml += '<span> Save '+ savePercent +'% ('+ this.formatMoney(savePrice) +') </span>';
      	itemPriceHtml += '</p><p class="cst_price_drop"></p>';
      
    } 
//   Boost 124791
  else if(tags.indexOf('product_ContactUs') > 0 ){
    itemPriceHtml += ' <div class="custom-price"> <p class="old-price"> Retail ' + this.formatMoney(data.compare_at_price_min) +' </p></div>';
    itemPriceHtml += '<div class="cst_col_p"> <a data-title="'+data.title+'" href="/pages/contact-us"><u>Contact us</u></a></div>';
    itemHtml = itemHtml.replace(/{{tagProductContactUs}}/g, 'tagProductContactUs');

        }
  else {
        itemPriceHtml += '<p data-comp="'+data.compare_at_price_min+'" class="regular-product 2 kaha_ho_tum black_clr"><span>';
        if (priceVaries) {
            itemPriceHtml += '<em>' + bcSfFilterConfig.label.from_price + ' </em>'
        }
//       if (soldOut) {
     if (soldOut && tags.indexOf('product_ContactUs') < 1) {
//         itemPriceHtml += this.formatMoney(data.price, this.moneyFormat);
console.log('sold out if condition v1');

       if (data.compare_at_price_min == 0){
         // Boost 129309
    // itemPriceHtml += this.formatMoney(data.price, this.moneyFormat);
console.log('title ->'+data-title+'price ->'+data.price);
if (soldOut){

         itemPriceHtml += this.formatMoney(data.price, this.moneyFormat);
}
else{

    itemPriceHtml += this.formatMoney(data.compare_at_price_min, this.moneyFormat);
}
}
       else{      
console.log('sold out if condition v2');
   
if (soldOut){

         // Boost 129309
         // itemPriceHtml += this.formatMoney(data.price, this.moneyFormat);
         itemPriceHtml += this.formatMoney(data.price, this.moneyFormat);
}
else{
         itemPriceHtml += this.formatMoney(data.compare_at_price_min, this.moneyFormat);

}
       }
       
       
      } else {
console.log('sold out if condition');
        itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
      }
        itemPriceHtml += '</span></p>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.show_vendor) {
        itemVendorHtml = '<div class="product-vendor">' + data.vendor + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add to cart
    var itemAddToCartHtml = '<form action="/cart/add" method="post" class="variants" id="product-actions-{{itemId}}" enctype="multipart/form-data" style="padding:0px;">';
    if (soldOut) {
        itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.unavailable + '" disabled="disabled"/>';
    } else {
        if (data.variants.length > 1) {
            itemAddToCartHtml += '<input class="btn" type="button" onclick="window.location.href=\'{{itemUrl}}\'" value="' + bcSfFilterConfig.label.select_options + '" />';
        } else {
            itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
            itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.add_to_cart + '" />';
        }
    }
    itemAddToCartHtml += '</form>';
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

    // Add Quick view
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.enable_quick_view) {
        itemQuickViewHtml = bcSfFilterTemplate.quickViewHtml;
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Review
    var itemReviewHtml = bcSfFilterConfig.custom.display_product_reviews ? bcSfFilterTemplate.reviewHtml : '';
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add Color Swatches
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

    // Add Wishlist
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlist(data));
	
  	var title = data.title;
    if (this.getProductMetafield(data, 'short_title', 'Short Title') !== null) {
      title = this.getProductMetafield(data, 'short_title', 'Short Title')
    }
  
  	var ogtitle = title;
  	var spmtitle = ogtitle;
    if (this.getProductMetafield(data, 'singleproductmeta', 'Single Product Name') !== null) {
        spmtitle = this.getProductMetafield(data, 'singleproductmeta', 'Single Product Name')
    }
  
  	itemHtml = itemHtml.replace(/{{itemOgTitle}}/g, ogtitle);
  	itemHtml = itemHtml.replace(/{{itemSpmTitle}}/g, spmtitle);



 if (data.tags.indexOf('ship_2-3') >= 0){

	itemHtml = itemHtml.replace(/{{nofastshiplabel}}/g, 'nofastship');
}
  else{
itemHtml = itemHtml.replace(/{{nofastshiplabel}}/g, '');
}

setTimeout(function(){
var data_ship = "";
jQuery('div#bc-sf-filter-products > div').each(function(){
var get_ship_val = jQuery(this).attr('data-ship');
if (get_ship_val != ''){
data_ship = get_ship_val;
    
}
    
        
    });
console.log('get ship value',data_ship);
  if (data_ship == "nofastship" ){
jQuery('.cst_fast_ships label').show();
} 
  else{
jQuery('.cst_fast_ships label').hide();

}
}, 700);
  
  

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
   itemHtml = itemHtml.replace(/{{cstProductID}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);

// check for cst discount value

var totlurl = 'https://watchesandbeyond.com/products/'+data.handle;
//console.log(totlurl);
jQuery.ajax({
      type: 'GET', 
      url: totlurl,
      dataType: 'html', 
     
success: function(ds) {
      
var metafield_val = $(ds).find('#tmkc_coll_val').val();
console.log('metafield_val',metafield_val);
//jQuery('div#bc-sf-filter-products > div[data-id="'+data.id+'"]').find('.cst_price_drop').html(metafield_val);

  function isNullOrUndefined(value) {
  return value === undefined || value === null;
}

if(isNullOrUndefined(metafield_val)){
}
else{
 jQuery('div#bc-sf-filter-products > div[data-id="'+data.id+'"]').find('.product-bottom').addClass('discount_flash_active');
 jQuery('div#bc-sf-filter-products > div[data-id="'+data.id+'"]').find('.product-bottom .price-box').after('<p class="cst_discountflash">'+metafield_val+'</p>');
}


    }

});



// check for cst discount value
  
$.each( data.collections, function( key, value ) {
 if (value.title === "PRICE DROPS"){

	itemHtml = itemHtml.replace(/{{dataPriceDropFlag}}/g, 'qv_cst_pda');
//console.log('drop coll true');
 return false;
}
 
});

$.each( data.collections, function( key, value ) {
 if (value.title == "PRICE DROPS"){

	
}
else{
itemHtml = itemHtml.replace(/{{dataBadgeFlag}}/g, 'newbadgeflag');
//console.log('drop coll true');
 return false;
}
 
});



  
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

BCSfFilter.prototype.buildProductListItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
  	//console.dir(data);
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add class
    itemHtml = soldOut ? itemHtml.replace(/{{itemSoldOutClass}}/g, bcSfFilterTemplate.soldOutClass) : itemHtml.replace(/{{itemSoldOutClass}}/g, '');
    itemHtml = onSale ? itemHtml.replace(/{{itemSaleClass}}/g, bcSfFilterTemplate.onSaleClass) : itemHtml.replace(/{{itemSaleClass}}/g, '');
    itemHtml = itemHtml.replace(/{{delayTime}}/g, bcSfFilterConfig.custom.time_lazy_load * index);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Label
    var itemLabelsHtml = '';
    if (onSale || soldOut) {
        itemLabelsHtml += '<div class="product-label">';
        if (onSale) {
            itemLabelsHtml += '<strong class="label">' + bcSfFilterConfig.label.sale + '</strong>';
        }
        if (soldOut) {
            itemLabelsHtml += '<strong class="sold-out-label">' + bcSfFilterConfig.label.sold_out + '</strong>';
        }
        itemLabelsHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<p class="sale">';
        itemPriceHtml += '<span class="old-price money"> ' + this.formatMoney(data.compare_at_price_min) +'</span>';
        if (priceVaries) {
            itemPriceHtml += '<span class="special-price"><em>' + bcSfFilterConfig.label.from_price + ' </em>';
        } else {
            itemPriceHtml += '<span class="special-price">';
        }
        itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        itemPriceHtml += '</span></p>';
    } else {
        itemPriceHtml += '<p class="regular-product">';
        if (priceVaries) {
            itemPriceHtml += '<span class="money"><em>' + bcSfFilterConfig.label.from_price + ' </em>' + this.formatMoney(data.price_min) + '</span>';
        } else {
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
        }
        itemPriceHtml += '</p>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.show_vendor) {
        itemVendorHtml = '<div class="product-vendor">' + data.vendor + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add to cart
    var itemAddToCartHtml = '<form action="/cart/add" method="post" class="variants" id="product-actions-{{itemId}}" enctype="multipart/form-data" style="padding:0px;">';
    if (soldOut) {
        itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.unavailable + '" disabled="disabled"/>';
    } else {
        if (data.variants.length > 1) {
            itemAddToCartHtml += '<input class="btn" type="button" onclick="window.location.href=\'{{itemUrl}}\'" value="' + bcSfFilterConfig.label.select_options + '" />';
        } else {
            itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
            itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.add_to_cart + '" />';
        }
    }
    itemAddToCartHtml += '</form>';
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

    // Add Quick view
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.enable_quick_view) {
        itemQuickViewHtml = bcSfFilterTemplate.quickViewHtml;
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Review
    var itemReviewHtml = bcSfFilterConfig.custom.display_product_reviews ? bcSfFilterTemplate.reviewHtml : '';
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add Color Swatches
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

    // Add Wishlist
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlist(data));

    // Add Description
    var itemDescription = '';
    if (data.body_html.indexOf('[countdown]') !== -1) {
        itemDescription = jQ('<p>' + data.body_html + '</p>').text();
        var tempArr = itemDescription.split('[/countdown]');
        itemDescription = tempArr.pop();
        itemDescription = this.truncateByWord(itemDescription, 50);
    }
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  	
  	var title = data.title;
    if (this.getProductMetafield(data, 'short_title', 'Short Title') !== null) {
      title = this.getProductMetafield(data, 'short_title', 'Short Title');
    }
  
  	var ogtitle = title;
  	var spmtitle = ogtitle;
    if (this.getProductMetafield(data, 'singleproductmeta', 'Single Product Name') !== null) {
        spmtitle = this.getProductMetafield(data, 'singleproductmeta', 'Single Product Name');
    }
  
  	itemHtml = itemHtml.replace(/{{itemOgTitle}}/g, ogtitle);
  	itemHtml = itemHtml.replace(/{{itemSpmTitle}}/g, spmtitle);
  
    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Build Wishlist
function buildWishlist(data) {
    // Add Wishlist
    var wishlistHtml = '';
    if (bcSfFilterConfig.custom.enable_wishlist) {
        if (bcSfFilterConfig.customer.email != '') {
            var value = (data.id).toString();
            var productId = (data.id).toString();
            for (var k in bcSfFilterConfig.customer.tags) {
                var tagID = bcSfFilterConfig['customer']['tags'][k];
                if (tagID.indexOf(productId) > -1) {
                    value = 'x' + tagID;
                }
                if (value.length == 0) value = productId;
            }
            if (value.length > 0) {
                var check = ((value.length - productId.length) / 2).toString();
                check = check.split('.');
                var display = check.length > 1 && check[1].indexOf('5') > - 1 ? false : true;
            }
            if (typeof display !== 'undefined' && display == true) {
                wishlistHtml += '<form method="post" action="/contact#contact_form" class="contact-form" accept-charset="UTF-8">';
                wishlistHtml += '<input type="hidden" value="customer" name="form_type">';
                wishlistHtml += '<input type="hidden" name="utf8" value="✓">';
                wishlistHtml += '<input type="hidden" name="contact[email]" value="' + bcSfFilterConfig.customer.email + '"/>';
                wishlistHtml += '<input type="hidden" name="contact[tags]" value="' + value + '" />';
                wishlistHtml += '<button type="button" class="wishlist">' + bcSfFilterConfig.label.add_to_wishlist + '</button>';
                wishlistHtml += '</form>';
            } else {
                wishlistHtml += '<a class="wishlist" href="/pages/wish-list" title="' + bcSfFilterConfig.label. wishlist_note + '">' +
                                    '<span class="icon"></span>' +
                                    '<span class="wishlist_text">' + bcSfFilterConfig.label.added_to_wishlist + '</span>' +
                                '</a>';
            }
        } else {
            wishlistHtml = '<a class="wishlist" href="/account/login" title="' + bcSfFilterConfig.label.add_to_wishlist + '">' +
                                    '<span class="icon"></span>' +
                                    '<span class="wishlist_text">' + bcSfFilterConfig.label.add_to_wishlist + '</span>' +
                                '</a>';
        }
    }
    return wishlistHtml;
}

// Build Color Swatches
function buildColorSwatches(data) {
    var colorSwatchesHtml = '';
    if (bcSfFilterConfig.custom.display_item_swatch) {
        colorSwatchesHtml += '<ul class="item-swatch">';
        for (var index in data.options) {
            var option = data['options'][index].toLowerCase();
            if (option == 'color') {
                var colorlist = '';
                var color = '';
                for (var k in data.variants) {
                    var variant = data['variants'][k];
                    color = variant['options'][index];
                    if (colorlist.indexOf(color) == -1) {
                        var text = bcsffilter.slugify(color);
                        var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
                        var fileUrl = bcSfFilterConfig.general.file_url.split(/\/(?=[^\/]+$)/);
                        var imageSwatchUrl = fileUrl[0] + '/' + bcsffilter.slugify(color.toLowerCase()) + '_grande.png' + fileUrl[1];
                        colorSwatchesHtml += '<li>';
                        colorSwatchesHtml += '<label style="' + border + ' background-color: ' + bcsffilter.slugify(color.split(' ').pop()) + '; background-image: url(' + imageSwatchUrl + ');"></label>';
                        if (variant.image !== null) {
                            colorSwatchesHtml += '<div class="hidden">' +
                                                    '<a href="' + bcsffilter.optimizeImage(variant.image, 'grande') + '"></a>' +
                                                  '</div>';
                        }
                        colorSwatchesHtml += '</li>';
                        var templist = colorlist + color + ' ';
                        colorlist = templist;
                    }
                }
            }
        }
        colorSwatchesHtml += '</ul>';
    }
    return colorSwatchesHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        paginationHtml = jQ.parseHTML(paginationHtml);
        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    var _this = this;
    jQ('.dropdown-menu li').removeClass('active');
    jQ('.dropdown-menu li').each(function() {
        if (jQ(this).children().attr('href') == _this.queryParams.sort) {
            jQ(this).addClass('active');
            jQ('.filter-sortby button span').text(jQ(this).children().text());
        }
    });
};
BCSfFilter.prototype.buildSortingEvent = function() {
    var _this = this;
    jQ('.dropdown-menu ' + ' li a').click(function(e) {
        onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).attr('href'));
    })
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
    var itemHtml = '<label>' + bcSfFilterConfig.label.view_as + '</label>';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="' + bcSfFilterConfig.label.grid_view + '" class="grid bc-sf-filter-display-grid"><span>' + bcSfFilterConfig.label.grid_view  + '</span></a> ';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="' + bcSfFilterConfig.label.list_view  + '" class="list bc-sf-filter-display-list"><span>' + bcSfFilterConfig.label.list_view  + '</span></a>';
    itemHtml = jQ.parseHTML(itemHtml);
    jQ(this.selector.topDisplayType).html(itemHtml);

    // Active current display type
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
    if (this.queryParams.display == 'list') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
    } else if (this.queryParams.display == 'grid') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
    }
};

BCSfFilter.prototype.buildExtrasProductList = function(data) {
    $('#bc-sf-filter-products').removeClass();
    if (this.queryParams.display == 'list') {
        $('#bc-sf-filter-products').addClass('product-list');
    } else {
        $('#bc-sf-filter-products').addClass('product-collection products-grid row');
    }
};

//var totalFastShipping = 0
//var totalProducts = 0;

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    // Call Theme functions
    bcElla.initQuickView();
    bcElla.initAddToCart();
    bcElla.initProductWishlist();
    bcElla.initRemoveWishlist();
//   	bcElla.initResizeImage();
//   	if( $('body#mens-watches').length > 0 ){
//     	if( getParameterByName('pf_t_brand') == null ){
//        		$('.bc-sf-filter-option-block-series').addClass('bc-sf-filter-option-hidden'); 	
//     	}
//     }
//   	function getParameterByName(name, url) {
// 	   if (!url) url = window.location.href;
// 	   name = name.replace(/[\[\]]/g, "\\$&");
// 	   var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),   results = regex.exec(url);
// 	   if (!results) return null;
// 	   if (!results[2]) return null;
// 	   return decodeURIComponent(results[2].replace(/\+/g, " "));
// 	}
//     if( data.total_product == 0 ){
//       $('body').find('.toolbar .filter-sortby').hide();
//     }
  
  /*  var ship = data.filter.options.find(filter => filter.filterOptionId === 'pf_t_ship');
    if (ship) {
      try {
        totalFastShipping = ship.values[0].doc_count;
      } catch (e) {
        console.log(e);
      }
    } */
  
    // totalProducts = data.total_product;
  
    //checkFastShipping();
  
    jQ('.bc-sf-custom-product-count').empty();

    jQ('.bc-sf-custom-product-count').text('(' + data.total_product + ')');
  
    if (eventType === 'clearAllFilterOptions') jQ('#cst_ships_two_three').prop('checked', false);
};

/* function checkFastShipping() {
  jQ('.bc-sf-custom-product-count').empty();
  
  jQ('.bc-sf-custom-product-count').text('(' + totalProducts + ')');
} */

jQ('#cst_ships_two_three').change(function(e) {
  e.stopPropagation();
  e.preventDefault();
  
  var value = jQ('#cst_ships_two_three').is(':checked') ? 'ship:fast shipping' : '';
  var id = 'pf_t_ship';
  
  var newUrl = bcsffilter.buildFilterOptionLink(id, value, 'tag', 'list', 'single');
  bcsffilter.onChangeData(newUrl, 'tag', value, id);
});

// Rebuild the swatch image in the filter option
BCSfFilter.prototype.buildFilterOptionSwatchData = function(fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData) {
    if (this.checkShowFilterOptionItem(fOItemValue, fOData)) {
        var iLabel = fOItemValue.key, iValue = fOItemValue.key;
        var swatchName = iValue;
        if (fOType == 'collection') {
            iLabel = fOItemValue.label, iValue = fOItemValue.handle;
            swatchName = iLabel;
        }

        var colorOptionsArr = this.getSettingValue('general.colorOptionsArr');
        // Get prefix of swatch from filter option id
        // Ex: By option: pf_opt_color -> color, pf_opt_size -> size
        //     By tag: pf_t_color -> color, pf_t_dimension -> dimension
        var prefixSwatch = fOId.replace('pf_t_', '').replace('pf_opt_', '');
        // Deprecated
        if (colorOptionsArr != '') {
            var isColor = colorOptionsArr.filter(function(item) {
                return fOId.indexOf(item) > -1;
            });
            if (typeof isColor[0] !== 'undefined') {
                prefixSwatch = 'color';
            }
        }
        // Get Swatch name
        swatchName = this.customizeSwatchFileName(swatchName, fOItemValue, fOData);
        // Get item HTML Template & Build data
        var html = this.getTemplate('filterOptionSwatchItem');
        html = this.buildFilterOptionItem(html, iLabel, iValue, fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData);
        // Add Image
        var filePath = getFilePath(swatchName, this.swatchExtension, this.getSettingValue('general.swatchImageVersion'));
        html = html.replace(/{{itemImageValue}}/g, filePath);
        // Add border
        var border = fOData.hasOwnProperty('borderSwatch') && fOData.borderSwatch != '' ? fOData.borderSwatch : 'none';
        html = html.replace(/{{itemBorder}}/g, border);
        return html;
    }
    return '';
};


// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};
// (function($) {
//   $(window).on('load', function() {
//       if( $('body#mens-watches').length > 0 ){
//           console.log( 'Runnnn' );
//           $('.bc-sf-filter-option-block-series').addClass('bc-sf-filter-option-hidden');
//       }
// 	});
// })(jQuery);

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

BCSfFilter.prototype.buildFilterSelectionData = function(data) {
    function buildItem(template, title, label, clearLink) {
        template = template.replace(/{{itemType}}/g, title);
        template = template.replace(/{{itemLabel}}/g, label);
        template = template.replace(/{{itemLink}}/g, clearLink);
        return template;
    }

    var _this = this;
    var verticalContent = horizontalContent = '';
    var itemVerticalHtml = this.getTemplate('filterRefineItem');
    var itemHorizontalHtml = this.getTemplate('filterRefineHorizontalItem');
    var options = data.filter.options;

    // Get all params that have on URL
    var paramKeys = Object.keys(_this.queryParams);
    paramKeys = paramKeys.filter(function(key) {
        return key.indexOf('pf_') == 0 && key !== 'pf_t_ship'
    });

    jQ.each(paramKeys, function(i, key) {
        var selectedOption = options.filter(function(e) { return e.filterOptionId == key })[0];
        if (typeof selectedOption !== 'undefined' && _this.queryParams.hasOwnProperty(key) && _this.queryParams[key] && _this.queryParams[key].length) {
            var values = _this.queryParams[key],
                fOId = selectedOption.filterOptionId,
                prefix = selectedOption.prefix,
                title = selectedOption.label,
                fType = selectedOption.filterType,
                fODisplayType = selectedOption.displayType;
            prefix = typeof prefix !== 'undefined' && prefix !== null && prefix !== false ? prefix.replace(/\\/g, '') : '';
            if (!Array.isArray(values)) values = [values];
            // Fix email campaign issue
            // values = values.map(function(value) {
            //     return value.toString().replace(/\+/g, '%20');
            // });

            if (fODisplayType == 'range') {
                /* RANGE SLIDER
                *  - Is advanced range slider: Get first value and last value for min-max
                *  - Is general range slider:  Split value by ":" to get min-max
                **/
                var label = '';
                if ((fType.indexOf('price') == -1 && fType.indexOf('variants_price') == -1) && fType !== 'weight' && fType.indexOf('range_slider') == -1) {
                    // Return an Array of values
                    var rangeValues = []
                    if (selectedOption && selectedOption.hasOwnProperty('values')) {
                        rangeValues = selectedOption['values'].map(function(value) {
                            return value.key;
                        });
                    }
                    // Get min/max label from URL
                    var currentLabels = rangeValues.length ? _this.getAdvancedRangeSelectedValues(values, rangeValues) : [values[0], values[values.length - 1]];
                    label = currentLabels[0].toString().replace(prefix, '');
                    if (values.length > 1) {
                        label += ' - ' + currentLabels[1].toString().replace(prefix, '');
                    }
                } else {
                    var value = values[0], elements = value.split(':');
                    if (fType == 'price' || fType == 'variants_price') {
                        var minPrice = _this.formatMoney(elements[0] * 100),
                            maxPrice = _this.formatMoney(elements[1] * 100);
                        if (_this.getSettingValue('general.removePriceDecimal')) {
                            minPrice = _this.removeDecimal(minPrice), maxPrice = _this.removeDecimal(maxPrice);
                        }
                        label = minPrice + ' - ' + maxPrice;
                    } else {
                        label = elements[0] + ' - ' + elements[1];
                    }
                }
                var clearLink = _this.buildClearFilterOptionLink(fOId, title, values);
                verticalContent += buildItem(itemVerticalHtml, title, label, clearLink);
                horizontalContent += buildItem(itemHorizontalHtml, title, label, clearLink);
            } else {
                for (var i = 0; i < values.length; i++) {
                    var value = values[i], label = value;
                    // Customize label
                    label = _this.customizeFilterOptionLabel(label, prefix, fType);
                    var clearLink = _this.buildClearFilterOptionLink(fOId, title, value);
                    // Remove the prefix in label
                    if (typeof prefix !== 'undefined' && prefix !== null && prefix !== false) {
                        prefix = prefix.replace(/\\/g, '');
                        value = value.replace(prefix, '').trim();
                    }
                    switch(fType) {
                        case 'price': 
                        case 'variants_price':
                        label = _this.getPriceLabel(value); break;
                        case 'percent_sale': label = _this.getPercentSaleLabel(value); break;
                        case 'stock': label = (value === 'true') ? selectedOption.values[0].label : selectedOption.values[1].label; break;
                        case 'review_ratings':
                            var showExactRating = selectedOption.hasOwnProperty('showExactRating')? selectedOption.showExactRating: false;
                            label = _this.getReviewRatingsLabel(value, showExactRating);
                            break;
                    }
                    verticalContent += buildItem(itemVerticalHtml, title, label, clearLink);
                    horizontalContent += buildItem(itemHorizontalHtml, title, label, clearLink);
                }
            }
        }
    });

    return [verticalContent, horizontalContent];
};